import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { InsuranceCoverageStatusOverviewEmailEditTemplate } from 'themes/application/insurance-coverage-status-overview/pages';
import { InsuranceCoverageStatusOverviewEmailEditViewStore } from 'application/insurance-coverage-status-overview/stores';

@setCurrentView((rootStore) => new InsuranceCoverageStatusOverviewEmailEditViewStore(rootStore), 'insuranceCoverageStatusOverviewEmailEditViewStore')
@observer
class InsuranceCoverageStatusOverviewEmailEdit extends React.Component {
    render() {
        return <InsuranceCoverageStatusOverviewEmailEditTemplate {...this.props} />
    }
}

export default InsuranceCoverageStatusOverviewEmailEdit;
